import Button from "@mui/material/Button";
import Testo from "../elementi/Testo";
import { monFetch } from "../inc/inc";
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { useState, useEffect } from "react";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import DeleteIcon from "@mui/icons-material/Delete";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import PopupElimina from "../elementi/PopupElimina";

import SottosezioniModifica from "./SottosezioniModifica";

const Comp = (props) => {
  //const ruoloLogin = controllaLogin();
  let params = useParams();
  let id = params.id;

  const [nome, setNome] = useState("");
  const [descrizione, setDescrizione] = useState("");
  const [colore, setColore] = useState("");
  const [sottosezioni, setSottosezioni] = useState([]);

  const [popupElimina, setPopupElimina] = useState(false);
  const [sezioneDaEliminare, setSezioneDaEliminare] = useState(null);

  const [modificaSottosezione, setModificaSottosezione] = useState(false);
  const [idSottosezione, setIdSottosezione] = useState(null);

  async function querySezione(id) {
    const res = await monFetch("/sectionGet", {
      id: id,
    });
    // console.log(res);
    const sezione = res.section;
    setNome(sezione.name);
    setDescrizione(sezione.description);
    setColore(sezione.color);
  }

  async function salvaSezione(e) {
    e.preventDefault();

    // console.log(password);
    // return
    const res = await monFetch("/sectionSet", {
      id: id,
      name: nome,
      description: descrizione,
      color: colore
    });
    // console.log(res);

    if (res.success) {
      if (res.id) {
        window.location.href = process.env.PUBLIC_URL + "/sezione/" + res.id;
      } else {
        window.location.href = process.env.PUBLIC_URL + "/sezioni/";
      }
    }
  }

  async function querySottosezioni() {
    const res = await monFetch("/subsectionList", {
      section_id: id,
    });
    // console.log(res);
    setSottosezioni(res.subsection);
  }

  async function eliminaSottosezione(id) {
    const res = await monFetch("/subsectionDelete", { id });
    // console.log(res);
    setPopupElimina(false);
    querySottosezioni();
  }

  async function settaOrdinamento(idSezione, direzione, idSezionePadre) {
    //$direzione 1 = porta dopo
    //$direzione 0 = porta prima
    const res = await monFetch("/subsectionOrder", {
      direction: direzione,
      subsection_id: idSezione,
      section_id: idSezionePadre,
    });
    querySottosezioni();
  }

  useEffect(() => {
    props.setTestoTitolo(props.nuovo ? "Aggiungi Sezione" : "Modifica Sezione");
    if (id) {
      querySezione(id);
    }
    querySottosezioni();
  }, []);

  return (
    <>
      <form onSubmit={(e) => salvaSezione(e)}>
        <Grid container spacing={2}>
          <Grid item sm={4} xs={12}>
            <Testo
              required
              label="Nome"
              value={nome}
              onChange={(e) => {
                setNome(e.target.value);
              }}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <Testo
              // required
              label="Descrizione"
              value={descrizione || ""}
              onChange={(e) => {
                setDescrizione(e.target.value);
              }}
            />
          </Grid>
          <Grid item sm={4} xs={12} style={{ display: "flex" }}>
            <label>Colore Grafico:</label>
            <input
              type="color"
              style={{ flexGrow: 1, marginLeft: 10, height: "35px" }}
              value={colore || ""}
              onChange={(e) => {
                setColore(e.target.value);
              }}
            />
          </Grid>

          <Grid item sm={12} xs={12}>
            <div className="flexSpaceBetween">
              <Button
                className="buttonIndietro"
                href={process.env.PUBLIC_URL + "/sezioni"}
                variant="contained"
              >
                Indietro
              </Button>
              <Button className="buttonSalva" type="submit" variant="contained">
                Salva
              </Button>
            </div>
          </Grid>
        </Grid>
      </form>
      {id && (
        <>
          <h4>Sottosezioni</h4>
          <Button
            variant="contained"
            // href={"/sottosezione-nuovo/" + id}
            onClick={(e) => {
              setModificaSottosezione(true);
              setIdSottosezione(null);
            }}
          >
            Nuova{" "}
          </Button>
          <div id="modificaSottosez">
            {modificaSottosezione && (
              <div style={{ marginTop: 20 }} className="boxColor bgColor2">
                <SottosezioniModifica
                  nuovo={true}
                  idSezione={id}
                  id={idSottosezione}
                  setModificaSottosezione={setModificaSottosezione}
                  querySottosezioni={querySottosezioni}
                />
              </div>
            )}
          </div>

          <Table>
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Nome</TableCell>
                <TableCell>Descrizione</TableCell>
                <TableCell></TableCell>
                <TableCell>Domande</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sottosezioni.map((sezione, index) => {
                let mostraFrecciaSu = true;
                let mostraFrecciaGiu = true;
                if (index == 0) {
                  mostraFrecciaSu = false;
                }
                if (index == sottosezioni.length - 1) {
                  mostraFrecciaGiu = false;
                }

                return (
                  <TableRow
                    key={sezione.id}
                    className="rigaSelezionabile"
                    onClick={(e) => {
                      setIdSottosezione(sezione.id);
                      setModificaSottosezione(true);
                      document
                        .getElementById("modificaSottosez")
                        .scrollIntoView();
                      // window.location.href = process.env.PUBLIC_URL+"/sottosezione/" + sezione.id;
                    }}
                  >
                    <TableCell style={{ width: 50 }}>{sezione.order}</TableCell>
                    <TableCell>{sezione.name}</TableCell>
                    <TableCell>{sezione.description}</TableCell>
                    <TableCell>
                      <a
                        onClick={(e) => {
                          e.stopPropagation();
                          settaOrdinamento(sezione.id, 0, sezione.section_id);
                        }}
                      >
                        <KeyboardArrowUpIcon
                          style={{ opacity: mostraFrecciaSu ? 1 : 0.4 }}
                        />
                      </a>
                      <a
                        onClick={(e) => {
                          e.stopPropagation();
                          settaOrdinamento(sezione.id, 1, sezione.section_id);
                        }}
                      >
                        <KeyboardArrowDownIcon
                          style={{ opacity: mostraFrecciaGiu ? 1 : 0.4 }}
                        />
                      </a>
                    </TableCell>
                    <TableCell>{sezione.hasQuestions}</TableCell>
                    <TableCell>
                      {sezione.hasQuestions > 0 ? (
                        <DeleteIcon
                          color="error"
                          style={{ opacity: 0.4 }}
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        />
                      ) : (
                        <DeleteIcon
                          color="error"
                          onClick={(e) => {
                            e.stopPropagation();
                            setPopupElimina(true);
                            setSezioneDaEliminare(sezione.id);
                          }}
                        />
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </>
      )}
      <PopupElimina
        open={popupElimina}
        fnAnnulla={(e) => setPopupElimina(false)}
        fnSuccess={(e) => eliminaSottosezione(sezioneDaEliminare)}
      />
    </>
  );
};

export default Comp;
